import { isNil } from 'es-toolkit';

function getIsBrowser() {
  return typeof window !== 'undefined';
}

function parseJson(data: string) {
  try {
    const parsed: unknown = JSON.parse(data);
    return parsed;
  } catch {
    return null;
  }
}

export function getTableLocalStorageKey({
  prefix,
  tableName,
  storageKey,
  persist,
}: {
  readonly prefix: string;
  readonly tableName: string | undefined;
  readonly storageKey: string | undefined;
  readonly persist: boolean;
}) {
  if (!persist) return null;
  if (!isNil(storageKey) && storageKey.length > 0) return storageKey;
  if (isNil(tableName) || tableName.length === 0) return null;
  return `${prefix}${tableName}`;
}

export function getStoredTableValue<T>(storageKey: string, isValid: (data: unknown) => data is T): T | null {
  if (!getIsBrowser()) return null;

  try {
    const stored = window.localStorage.getItem(storageKey);
    if (isNil(stored)) return null;

    const parsed = parseJson(stored);
    return isValid(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function setStoredTableValue(storageKey: string, value: unknown): void {
  if (!getIsBrowser()) return;

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(value));
  } catch {
    // Storage may be unavailable in private browsing or locked-down contexts.
  }
}
